import PropTypes from "prop-types";

const DefaultMapPin = ({ width = 37, height = 47 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 42 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_f_7050_12755)">
      <ellipse
        cx="21"
        cy="49.5"
        rx="7"
        ry="2.5"
        fill="black"
        fillOpacity="0.2"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 0C32.598 0 42 9.40202 42 21C42 29.8926 36.4727 37.4942 28.6663 40.5567L22.1961 49.4007C22.0612 49.5858 21.8821 49.7369 21.6739 49.8412C21.4657 49.9455 21.2346 50 21 50C20.7654 50 20.5343 49.9455 20.3261 49.8412C20.1179 49.7369 19.9388 49.5858 19.8039 49.4007L13.3337 40.5567C5.52726 37.4941 0 29.8926 0 21C0 9.40202 9.40202 0 21 0Z"
      fill="#7B9E7E"
    />
    <path
      d="M29 29C29 29.2653 28.8946 29.5196 28.7071 29.7071C28.5196 29.8947 28.2652 30 28 30H14C13.7348 30 13.4804 29.8947 13.2929 29.7071C13.1054 29.5196 13 29.2653 13 29V20H10L20.327 10.612C20.5111 10.4445 20.7511 10.3517 21 10.3517C21.2489 10.3517 21.4889 10.4445 21.673 10.612L32 20H29V29Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_f_7050_12755"
        x="12"
        y="45"
        width="18"
        height="9"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="1"
          result="effect1_foregroundBlur_7050_12755"
        />
      </filter>
    </defs>
  </svg>
);

const { number } = PropTypes;

DefaultMapPin.propTypes = {
  width: number,
  height: number
};

export default DefaultMapPin;
